import { handleRequestPost, handleRequestGet } from '../axios';
import { parseResult, queryParamStr, queryParamStrArr } from './GeneralFunc';
import {logMessage} from '../../components/utils.js';
import { Modal } from 'antd';

export const searchClientNameAccount = async (keywords = null,mode=null) => {
    let url = '/client/account/options?status=1&size=100&page=1';
    if(mode){ //
        url += '&mode='+mode
    }
    if (keywords) url += '&term=' + keywords;
    let result = await handleRequestGet(url, {});
    return parseResult(result);
};

export const getClientProfile = async (a_id = null) => {
    let url = '/client/account/' + a_id + '/profile';
    let result = await handleRequestGet(url, {});
    return parseResult(result);
};

export const getClientAccDetail = async (a_id = null) => {
    let url = '/client/account/' + a_id + '/trust/currency/1'; //1 = myr currency
    let result = await handleRequestGet(url, {});
    return parseResult(result);
};

// /client/account/2/contract?currency=1&type=0&stock=58&range[start]=2022-01-01&range[end]=2022-12-31&size=100&page=1

export const getAccountContra = async (
    a_id = null,
    {
        currency = null,
        type = 0, //0 = outstanding purchase, 1 = outstanding sales
        size = 10
    },
    page = 1
) => {
    let url = '/client/account/' + a_id + '/contra?';

    let queryString = '';
    queryString += queryParamStr('currency', currency, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('size', size);
    queryString += queryParamStr('page', page);

    // queryString += queryParamStrArr('accounts[]', a_id);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});
    logMessage(fullUrl);
    logMessage(result);

    return parseResult(result);
};

export const getMultiAccountContra = async (
    acc_ids:any = null,
    {
        currency = null,
        type = null, //0 = outstanding purchase, 1 = outstanding sales
        size = 10,
        dateStart = null,
        dateEnd = null,
    },
    page = 1
) => {
    if(!acc_ids || acc_ids.length == 0){
        const modal = Modal.confirm({
            title: 'Info',
            content: <>
                <div>
                    <div className='pt-2'>Account number is required</div>
                    <div className='pt-4'>
                        <button 
                            className="btn-primary-custom btn-md" 
                            onClick={() => {
                                modal.destroy();  // This will close the modal when the button is clicked
                            }}
                        >Close</button>
                    </div>
                </div>
            </>,
            onOk() {
            //  console.log('Error modal closed');
            },
            okButtonProps: {
                style: { display: 'none' }

            },  
            cancelButtonProps: {
                style: { display: 'none' }, // This hides the Cancel button
            },
            className:"custom-error-modal text-center"
          
        });
        return null;
    }
 
    let url = '/client/contra?';

    let queryString = '';
    queryString += queryParamStr('currency', currency, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('size', size);
    queryString += queryParamStr('page', page);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);

    queryString += queryParamStrArr('accounts[]', acc_ids);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});
    logMessage(fullUrl);
    logMessage(result);

    return parseResult(result);
};

//{{host}}/client/account/2/contra?currency=1&type=0&size=100&page=1

export const getAccountContract = async (
    a_id = null,
    {
        currency = null,
        type = null, //0 = gain, 1=lose
        stock = null,
        dateStart = null,
        dateEnd = null,
        size = 10,
        statuses = null, // [0,3]
        exchanges = null
    },
    page = 1
) => {
    let url = '/client/account/' + a_id + '/contract?';
    let queryString = '';

    queryString += queryParamStr('currency', currency, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('stock', stock);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);
    queryString += queryParamStr('size', size);
    queryString += queryParamStr('page', page);

    queryString += queryParamStrArr('statuses[]', statuses);
    queryString += queryParamStrArr('exchanges[]', exchanges);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    logMessage('fullUrl', fullUrl);
    logMessage(result);

    return parseResult(result);
};

export const getAccountContractDetail = async (
    a_id: string,
    ctrt_id: string
) => {
    let url = '/client/account/' + a_id + '/contract/' + ctrt_id;
    let result = await handleRequestGet(url, {});
    return parseResult(result).contract || {};
};

export const getAccountContractSummary = async (
    a_id: string,
    {
        currency = null,
        stock = null,
        dateStart = null,
        dateEnd = null,
        type = null,
        types = null,
        status = null,
        statuses = null,
        settlementType=null
        // page = 1
    }
) => {
    // alert("jere")
    if(!a_id){
        const modal = Modal.confirm({
            title: 'Info',
            content: <>
                <div>
                    <div className='pt-2'>Account number is required</div>
                    <div className='pt-4'>
                        <button 
                            className="btn-primary-custom btn-md" 
                            onClick={() => {
                                modal.destroy();  // This will close the modal when the button is clicked
                            }}
                        >Close</button>
                    </div>
                </div>
            </>,
            onOk() {
            //  console.log('Error modal closed');
            },
            okButtonProps: {
                style: { display: 'none' }

            },  
            cancelButtonProps: {
                style: { display: 'none' }, // This hides the Cancel button
            },
            className:"custom-error-modal text-center"
          
        });
        return null;
    }
 
    let url = '/client/account/' + a_id + '/contract/summary?';
    let queryString = '';
    queryString += queryParamStr('stock', stock, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);

    queryString += queryParamStrArr('settlement_type', settlementType);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});
   // logMessage('fullUrl', url);
    return parseResult(result).summary || {};
};

//multi accounts
export const getMultiAccountContract = async (
    acc_ids:any = null,
    {
        currency = null,
        type = null, //0 = gain, 1=lose
        stock = null,
        dateStart = null,
        dateEnd = null,
        size = 10,
        statuses = null, // [0,3]
        types = null,
        exchanges = null,
        stocks = null,
        settlementType=null
    },
    page = 1
) => {
    let url = '/client/contract?';
    let queryString = '';

    queryString += queryParamStr('currency', currency, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('stock', stock);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);
    queryString += queryParamStr('size', size);
    queryString += queryParamStr('page', page);

    queryString += queryParamStrArr('types[]', types);
    queryString += queryParamStrArr('statuses[]', statuses);

    queryString += queryParamStrArr('exchanges[]', exchanges);
    queryString += queryParamStrArr('stocks[]', stocks);

    queryString += queryParamStrArr('accounts[]', acc_ids);

    queryString += queryParamStrArr('settlement_type', settlementType);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    return parseResult(result);
};

export const getMultiAccountContractSummary = async (
    acc_ids = null,
    {
        currency = null,
        type = null, //0 = gain, 1=lose
        stock = null,
        dateStart = null,
        dateEnd = null,
        statuses = null, // [0,3]
        types = null,
        exchanges = null,
        stocks = null
    }
) => {
    let url = '/client/contract/summary?';
    let queryString = '';

    queryString += queryParamStr('currency', currency, true);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('stock', stock);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);

    queryString += queryParamStrArr('types[]', types);
    queryString += queryParamStrArr('statuses[]', statuses);

    queryString += queryParamStrArr('exchanges[]', exchanges);
    queryString += queryParamStrArr('stocks[]', stocks);

    queryString += queryParamStrArr('accounts[]', acc_ids);

    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});

    logMessage('fullUrl', fullUrl);
    logMessage(result);

    return parseResult(result);
};

export const getMultiAccountContractDetail = async (ctrt_id: string) => {
    let url = '/client/contract/' + ctrt_id;
    let result = await handleRequestGet(url, {});
    return parseResult(result).contract || {};
};

export const getAccountSummary = async (a_id: string) => {
    if(!a_id){
        const modal = Modal.confirm({
            title: 'Info',
            content: <>
                <div>
                    <div className='pt-2'>Account number is required</div>
                    <div className='pt-4'>
                        <button 
                            className="btn-primary-custom btn-md" 
                            onClick={() => {
                                modal.destroy();  // This will close the modal when the button is clicked
                            }}
                        >Close</button>
                    </div>
                </div>
            </>,
            onOk() {
            //  console.log('Error modal closed');
            },
            okButtonProps: {
                style: { display: 'none' }

            },  
            cancelButtonProps: {
                style: { display: 'none' }, // This hides the Cancel button
            },
            className:"custom-error-modal text-center"
          
        });
        return null;
    }
    let url = '/client/account/' + a_id +"/summary";
    let result = await handleRequestGet(url, {});
    return parseResult(result) || {};
};

export const getAccountFinancialList = async (
    a_id: string,
    {
        size = 10,
        dateStart = null,
        dateEnd = null,
    },
    page = 1) => {
    let url = '/client/account/' + a_id +"/financial?";

    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);
    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);

    let fullUrl = url + queryString;

    let result = await handleRequestGet(fullUrl, {});
    return parseResult(result) || {};
};

//others
export const getMultiFinancialList = async (
    acc_ids:any = null,
    {
       // currency = null,
      //  type = null, //0 = outstanding purchase, 1 = outstanding sales
        size = 10,
        dateStart = null,
        dateEnd = null,
        exchanges = null,
        stocks = null,
        stock = null,
        type =null,
    },
    page = 1
) => {
    if(!acc_ids || acc_ids.length == 0){
        const modal = Modal.confirm({
            title: 'Info',
            content: <>
                <div>
                    <div className='pt-2'>Account number is required</div>
                    <div className='pt-4'>
                        <button 
                            className="btn-primary-custom btn-md" 
                            onClick={() => {
                                modal.destroy();  // This will close the modal when the button is clicked
                            }}
                        >Close</button>
                    </div>
                </div>
            </>,
            onOk() {
            //  console.log('Error modal closed');
            },
            okButtonProps: {
                style: { display: 'none' }

            },  
            cancelButtonProps: {
                style: { display: 'none' }, // This hides the Cancel button
            },
            className:"custom-error-modal text-center"
          
        });
        return null;
    }
 
    // let acc_id= acc_ids[0];
    let url = '/client/financial?';

    let queryString = '';
    // queryString += queryParamStr('currency', currency, true);
    // queryString += queryParamStr('type', type);
    queryString += queryParamStr('size', size);
    queryString += queryParamStr('page', page);

    queryString += queryParamStr('range[start]', dateStart);
    queryString += queryParamStr('range[end]', dateEnd);

    queryString += queryParamStrArr('accounts[]', acc_ids);
    queryString += queryParamStrArr('exchanges[]', exchanges);
    queryString += queryParamStrArr('stocks[]', stocks);

    queryString += queryParamStr('stock', stock);

    queryString += queryParamStrArr('types[]', type);

    let fullUrl = url + queryString;

    let result = await handleRequestGet(fullUrl, {});
    logMessage(fullUrl);
    logMessage(result);

    return parseResult(result);
};




//multi accounts end
